// extracted by mini-css-extract-plugin
export var chevron = "xfJ30ylLXUIfbo3tesXy";
export var close = "ygfjoGFA3tOkuvloCDlw";
export var collapseIcon = "Y2cWW9zXDI3QHxxLN6GM";
export var collapseTrigger = "eAUjaT20IchmBGkk8eVJ";
export var footerLabel = "KK3rUlxy9Hhvya9M9rKD";
export var open = "JobQEJTJiEzETaairkK0";
export var passengerList = "Q7yYbIceGaKjogY60ILC";
export var transitLegFooter = "DCzdHZv6QcubZCEZK2cw";